import httpClient from "@/api/httpClient";
import ReviewPage from "@/model/ReviewPage";
import ReviewRequest from "@/model/ReviewRequest";
import ReviewResponse from "@/model/ReviewResponse";

/** Public; with a token, the caller's own review comes back with mine=true. */
function listForProperty(
  propertyId: string,
  page: number,
  size: number,
  accessToken?: string
): Promise<ReviewPage> {
  return httpClient.getJson<ReviewPage>(
    `/api/properties/${propertyId}/reviews?page=${page}&size=${size}`,
    accessToken
  );
}

function getReview(id: string, accessToken?: string): Promise<ReviewResponse> {
  return httpClient.getJson<ReviewResponse>(`/api/reviews/${id}`, accessToken);
}

/** Reviews the stay of a booking (only its guest, after check-out, within 14 days). */
function createReview(
  accessToken: string,
  bookingId: string,
  request: ReviewRequest
): Promise<ReviewResponse> {
  return httpClient.postJson<ReviewResponse>(
    `/api/bookings/${bookingId}/review`,
    request,
    accessToken
  );
}

function updateReview(
  accessToken: string,
  id: string,
  request: ReviewRequest
): Promise<ReviewResponse> {
  return httpClient.putJson<ReviewResponse>(
    `/api/reviews/${id}`,
    request,
    accessToken
  );
}

function deleteReview(accessToken: string, id: string): Promise<void> {
  return httpClient.deleteNoContent(`/api/reviews/${id}`, accessToken);
}

const reviewsApi = {
  listForProperty,
  getReview,
  createReview,
  updateReview,
  deleteReview,
};

export default reviewsApi;
